import React, { useState } from "react";
import styled from "styled-components";
import { useMediaQuery } from 'react-responsive';
import SipkaPoplatky from "../../assets/img/sipkaPoplatky.svg";


const PujckaInner = styled.div`
  .pujcka {
    position: relative;
    
    button {
      cursor: pointer;
      background: none;
      border: 0;
      padding: 0;
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #333333;
      text-decoration: underline;
      vertical-align: middle;
      text-align: left;

      img {
        margin-left: 10px;
        vertical-align: middle;
        transition: all 0.3s;
      }
    }

    p {
      position: absolute;
      z-index: 100;
      top: calc(100% - 20px);
      left: 0;
      font-family: Visuelt-Regular;
      background: #FFFFFF;
      border: 1px solid #E1E1E1;
      box-shadow: 0 3px 15px 0 rgba(0,0,0,0.13);
      border-radius: 5px;
      font-size: 16px;
      color: #333333;
      line-height: 25px;
      padding: 20px;

      a {
        text-decoration: underline;
        white-space: nowrap;
      }
    }
  }

  .hidden {
    p {
      display: none;
    }

    img {
      transform: rotate(180deg);
      transition: all 0.3s;
    }
  }
`;


const NoWrap = styled.span`
  white-space: nowrap;
`;



const Pujcka = () => {

  const [poplatkyVisible, setPoplatkyVisible] = useState(false);

  const togglePoplatky = () => {
    if (poplatkyVisible) {
      setPoplatkyVisible(false);
    }

    else {
      setPoplatkyVisible(true);
    }
  }

  const isPlus1100 = useMediaQuery({
    query: '(min-width: 1100px)'
  });

  const isPlus900 = useMediaQuery({
    query: '(min-width: 900px)'
  });
  
  const isPlus360 = useMediaQuery({
    query: '(min-width: 360px)'
  });


  return (
    <PujckaInner>
      <div className={(!poplatkyVisible) ? "pujcka hidden" : "pujcka"}>
        <button onClick={() => togglePoplatky()}>Potřebujete si na pohřeb <NoWrap>půjčit? <img src={SipkaPoplatky} alt="" /></NoWrap></button>
        <p>Na pohřeb si u nás můžete půjčit až 150 tisíc korun. Prostřednictvím našich partnerů jsme vám schopni půjčku zařídit do 24 hodin. Při objednávání pohřbu přijměte naši cenovou nabídku a odemkne se Vám možnost financování. Pro více informací se neváhejte obrátit na naši pomocnou linku <a href="tel:315558136">315 558 136</a>.</p>
      </div>
    </PujckaInner>
  );
}

export default Pujcka;


